(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('ReportViewModel', reportViewModelFactory);

  /** @ngInject */
  function reportViewModelFactory(
    reportsFilterStore,
    localeFilters,
    devicesStore,
    deviceActions,
    facilityUtils,
    washBoxUtils,
    ReportTypeEnum,
    reportActions,
    DateTime,
    getUtcTimeService,
    layoutActions,
    sessionData,
    $state
  ) {
    function ReportViewModel(reportType) {
      this._devicesStoreChangeHandler = null;

      this.facilitiesVisible = false;
      this.periodsVisible = false;
      this.hoursVisibility = false;
      this.onlyMoneyReportVisibility = false;
      this.devices = [];
      this.reportFilter = {};
      this.dateFormat = localeFilters.defaultDateFormat;
      this.monthsList = new DateTime(null).listAllMonths();
      this.yearsList = new DateTime(null).listYears();
      this.hoursList = new DateTime(null).listHours();
      this.croatiaRegionVisibility =
        sessionData.getValue(sessionData.Keys.COUNTRY_CODE) === 'HR';
      init.call(this, reportType);
    }

    ReportViewModel.prototype.destroy = function () {
      devicesStore.off(
        devicesStore.events.CHANGE,
        this._devicesStoreChangeHandler
      );
    };

    ReportViewModel.prototype.setReportType = function (reportType, reportList) {
      if (reportList) {
        this.selectedReportsState = reportList.find(function (report) {
          return report.type === reportType;
        });
      }
      this.selectedReportType = reportType;
      this.facilitiesVisible =
        this.selectedReportType === ReportTypeEnum.COMPARE_PERIODS_REPORT ||
        this.selectedReportType === ReportTypeEnum.AVG_MONEY_BY_BOX_REPORT ||
        this.selectedReportType === ReportTypeEnum.CHANGER_INCOME ||
        this.selectedReportType === ReportTypeEnum.POS_INCOME;
      this.periodsVisible =
        this.selectedReportType === ReportTypeEnum.COMPARE_PERIODS_REPORT;
      this.hoursVisibility =
        this.selectedReportType === ReportTypeEnum.CHANGER_INCOME;
      this.onlyMoneyReportVisibility =
        this.selectedReportType === ReportTypeEnum.CHANGER_INCOME ||
        this.selectedReportType === ReportTypeEnum.R2W_BY_DATE_REPORT ||
        this.selectedReportType ===
          ReportTypeEnum.AVG_MONEY_BY_DAY_OF_WEEK_REPORT ||
        this.selectedReportType === ReportTypeEnum.MONEY_BY_DATE_REPORT ||
        this.selectedReportType === ReportTypeEnum.AVG_MONEY_BY_HOUR_REPORT ||
        this.selectedReportType === ReportTypeEnum.AVG_MONEY_BY_BOX_REPORT;
    };

    ReportViewModel.prototype.updateFilter = function () {
      layoutActions.showLoader();
      if (this.selectedReportsState) {
        $state.go(this.selectedReportsState.state);
      } else {
        $state.go('app.reports.dailyTotal');
      }
      reportActions.updateReportFilter(
        getUtcTimeService.getTime(this.fromDate),
        getUtcTimeService.getTime(this.toDate),
        this.selectedFacilitySerial,
        this.selectedFrom1,
        this.selectedTo1,
        this.selectedFrom2,
        this.selectedTo2,
        this.selectedFrom3,
        this.selectedTo3,
        localStorage.getItem(sessionData.Keys.CURRENCY)
      );
    };

    ReportViewModel.prototype.onPeriodFromChanged = function () {
      this.toOptions.minDate = this.fromDate;
    };

    ReportViewModel.prototype.onPeriodToChanged = function () {
      this.fromOptions.maxDate = this.toDate;
    };

    ReportViewModel.prototype.refresh = function (data) {
      if (data) {
        this.devices = parseDevicesData(data);
        this.selectedFacilitySerial =
          this.devices.length > 0 ? this.devices[0].facilityPointId : null;

        this.reportFilter = reportsFilterStore.getFilterData();

        this.fromDate = new Date(this.reportFilter.fromTimestamp);
        this.toDate = new Date(this.reportFilter.toTimestamp);

        this.selectedTo1 = this.reportFilter.period1To;
        this.selectedFrom1 = this.reportFilter.period1From;
        this.selectedTo2 = this.reportFilter.period2To;
        this.selectedFrom2 = this.reportFilter.period2From;
        this.selectedTo3 = this.reportFilter.period3To;
        this.selectedFrom3 = this.reportFilter.period3From;
        this.selectedCurrency = this.reportFilter.currency;

        this.updateFilter();
      }
    };

    return ReportViewModel;

    function init(reportType) {
      var that = this;

      this.setReportType(
        reportType ? reportType.type : ReportTypeEnum.MONEY_BY_DATE_REPORT
      );

      this._devicesStoreChangeHandler = function () {
        that.refresh.call(that);
      };

      devicesStore.on(
        devicesStore.events.CHANGE,
        this._devicesStoreChangeHandler
      );
    }

    function parseDevicesData(devicesJson) {
      var devices = [];

      if (devicesJson !== null) {
        devicesJson.forEach(function (deviceJson) {
          var facility = facilityUtils.getFacilityPoint(deviceJson),
            boxes = washBoxUtils.getWashBoxPoints(facility);
          var newDevice = {
            facilityPointId: facility.id,
            deviceSerial: deviceJson.deviceKey,
            name: facility.name,
            boxes: boxes.map(function (box) {
              return {
                pointId: box.id,
                name: box.name
              };
            })
          };
          this.push(newDevice);
        }, devices);
      }

      return devices;
    }
  }
})();
